export default __webpack_public_path__ + "static/media/three-vignette.12aa707f.frag";